import React from 'react';
import { Component } from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { RequestStatus, ExtendedStatusValidation } from 'stores/requests/requests-store';
import { IdentityService } from 'services/identity-service';
import { resolve } from 'inversify-react';
import { replaceAll } from 'utils/useful-functions';
import { userCanEditGeaOrGmaRequest } from 'utils/extended-requests-utils';

interface RequestEditButtonTailwindProps extends WithTranslation {
  requestId: string;
  requestStatus: RequestStatus;
  requestCreatorRoles: string[];
  isGea: boolean;
  isGma: boolean;
  extendedStatusValidation?: ExtendedStatusValidation;

  isOnEditMode: boolean;

  onEdit?: () => void;
  onSave?: () => void;
}

class RequestEditButtonTailwind extends Component<RequestEditButtonTailwindProps> {
  @resolve(IdentityService)
  private identityService: IdentityService;

  render() {
    if (!this.isVisible()) return <></>;

    if (!this.props.isOnEditMode) return this.renderEditButton();

    return this.renderSaveButton();
  }

  renderEditButton() {
    const { t } = this.props;
    return (
      <button
        type="button"
        className="flex-1 py-2 rounded border border-gray-400 text-gray-800 font-semibold hover:bg-gray-100 transition-all text-sm"
        onClick={() => this.props.onEdit && this.props.onEdit()}
        style={{ minWidth: 0 }}
      >
        <span className="flex items-center justify-center gap-1">
          {t('Edit')}
          <svg
            className="w-4 h-4 text-gray-800"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="m14.304 4.844 2.852 2.852M7 7H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-4.5m2.409-9.91a2.017 2.017 0 0 1 0 2.853l-6.844 6.844L8 14l.713-3.565 6.844-6.844a2.015 2.015 0 0 1 2.852 0Z"
            />
          </svg>
        </span>
      </button>
    );
  }

  renderSaveButton() {
    const { t } = this.props;
    return (
      <button
        type="button"
        className="flex-1 py-2 rounded border border-gray-400 text-gray-800 font-semibold hover:bg-gray-100 transition-all text-sm"
        onClick={() => this.props.onSave && this.props.onSave()}
        style={{ minWidth: 0 }}
      >
        {t('Save')}
      </button>
    );
  }

  isVisible(): boolean {
    return this.isVisibleInCurrentStatus() && this.currentUserHasPermission();
  }

  isVisibleInCurrentStatus(): boolean {
    return this.props.requestStatus.toString() === 'Draft' || this.props.requestStatus.toString() === 'Pending';
  }

  currentUserHasPermission(): boolean {
    const userInfo = this.identityService.getUserInfo();
    const { isGea, isGma, extendedStatusValidation, requestCreatorRoles, requestStatus } = this.props;

    if (IdentityService.isAdmin(userInfo)) return true;
    if (IdentityService.isReporting(userInfo)) return false;

    if ((requestCreatorRoles || []).includes(replaceAll(userInfo.activeRole, ' ', ''))) {
      if (isGma) return userCanEditGeaOrGmaRequest('GMA', extendedStatusValidation, requestCreatorRoles, requestStatus, userInfo);

      if (isGea) return userCanEditGeaOrGmaRequest('GEA', extendedStatusValidation, requestCreatorRoles, requestStatus, userInfo);

      return true;
    }
    return false;
  }
}

export default withTranslation()(RequestEditButtonTailwind);
